module.exports = __webpack_public_path__ + "fire-icon-1x.png";